import type { OrgState, VersionDiff } from "../types/org";

export function diffVersions(next: OrgState, previous?: OrgState): VersionDiff {
  if (!previous) {
    return {
      unitChanges: ["第一版正式版，無上一版可比較。"],
      employeeChanges: [],
      dashedLineChanges: [],
    };
  }

  const unitChanges: string[] = [];
  const employeeChanges: string[] = [];
  const dashedLineChanges: string[] = [];

  compareRecords(previous.units, next.units, (id, before, after) => {
    void id;
    if (!before && after) unitChanges.push(`新增單位：${after.nameZh}`);
    else if (before && !after) unitChanges.push(`刪除單位：${before.nameZh}`);
    else if (before && after) {
      if (before.nameZh !== after.nameZh) unitChanges.push(`單位名稱變更：${before.nameZh} → ${after.nameZh}`);
      if (before.code !== after.code) unitChanges.push(`${after.nameZh} 部門代碼變更：${before.code} → ${after.code}`);
      if (before.parentId !== after.parentId) unitChanges.push(`${after.nameZh} 上層單位變更`);
      if (before.managerEmployeeNo !== after.managerEmployeeNo) unitChanges.push(`${after.nameZh} 主管變更：${before.managerNameZh || "未指定"} → ${after.managerNameZh || "未指定"}`);
      if (before.mGrade !== after.mGrade) unitChanges.push(`${after.nameZh} M Grade 變更：${before.mGrade || "-"} → ${after.mGrade || "-"}`);
    }
  });

  compareRecords(previous.employees, next.employees, (_id, before, after) => {
    if (!before && after) employeeChanges.push(`新增員工：${after.chineseName}`);
    else if (before && !after) employeeChanges.push(`移除員工：${before.chineseName}`);
    else if (before && after) {
      if (before.unitId !== after.unitId) employeeChanges.push(`${after.chineseName} 轉調單位`);
      if (before.managerEmployeeNo !== after.managerEmployeeNo) employeeChanges.push(`${after.chineseName} 直屬主管變更`);
      if (before.pGrade !== after.pGrade) employeeChanges.push(`${after.chineseName} P Grade 變更：${before.pGrade || "-"} → ${after.pGrade || "-"}`);
      if (before.chineseName !== after.chineseName) employeeChanges.push(`員工姓名變更：${before.chineseName} → ${after.chineseName}`);
    }
  });

  const beforeDashed = new Set(previous.dashedEdges.map(edgeKey));
  const afterDashed = new Set(next.dashedEdges.map(edgeKey));
  for (const key of afterDashed) if (!beforeDashed.has(key)) dashedLineChanges.push(`新增虛線：${key}`);
  for (const key of beforeDashed) if (!afterDashed.has(key)) dashedLineChanges.push(`刪除虛線：${key}`);

  return { unitChanges, employeeChanges, dashedLineChanges };
}

function compareRecords<T>(before: Record<string, T>, after: Record<string, T>, visit: (id: string, before: T | undefined, after: T | undefined) => void) {
  const ids = new Set([...Object.keys(before), ...Object.keys(after)]);
  for (const id of ids) visit(id, before[id], after[id]);
}

function edgeKey(edge: { source: string; target: string }) {
  return `${edge.source} → ${edge.target}`;
}
